import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Bull from "../bullet/Bull";

export default function TextCard({ inputMessages, bgColor }: any) {
  const [messages, setMessages] = React.useState<string[]>([]);
  React.useEffect(() => {
    if (inputMessages) setMessages(inputMessages);
  }, [inputMessages]);
  const bull = <Bull scale="scale(2)" color="#e6123d" />;

  return (
    <Card className="marginRight-0 mTop10 mbottom20 iranSansMedium">
      <CardContent
        sx={{
          background: `${bgColor}`,
          textAlign: "justify",
          borderRadius: "14px",
        }}
      >
        {messages.map((message: string, index: number) => (
         
          <Typography key={index} color="text.secondary" gutterBottom>
            {bull}
            {message}
          </Typography>
        ))}
      </CardContent>
    </Card>
  );
}
